import { TableContainer, Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

import { formatWithCents } from '../../lib/Utils'

import { calculateLocalAdsSpend } from './localAdsTotals'
import OrganicCampaignDetailsListItems from './OrganicCampaignDetailsListItems'
import { channelTotals, emailTotals } from './statsTotals'

const useStyles = makeStyles()(() => {
  return {
    bottomCell: {
      borderBottom: 'none',
    },
  }
})

const OrganicCampaignDetailsList = ({ campaign, channel, stats }) => {
  const { classes } = useStyles()
  const theme = useTheme()

  //Display Alert if there are no shares for the selected channel
  if (campaign[channel] && !campaign[channel].length) {
    return (
      <Box display="flex" justifyContent="center" padding={theme.spacing(2)}>
        <Alert severity="info">
          {I18n.t('reporting.noReportingAvailable')}
        </Alert>
      </Box>
    )
  }
  return (
    <>
      {channel === 'instagram' && (
        <Box
          display="flex"
          justifyContent="center"
          textAlign="center"
          padding={2}
        >
          <Typography color="textSecondary" variant="body1">
            {I18n.t('reporting.onlyInstagramDesktop')}
          </Typography>
        </Box>
      )}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {channel === 'facebook' && (
                <TableCell style={{ width: 50 }}>Type</TableCell>
              )}
              <TableCell style={{ width: 50 }} />
              <TableCell style={{ width: 100 }}>
                {I18n.t('reporting.shareDate')}
              </TableCell>
              <TableCell>{I18n.t('reporting.shareName')}</TableCell>
              {channel !== 'instagram' && (
                <TableCell align="center" style={{ width: 150 }}>
                  {channel === 'facebook' && I18n.t('reporting.localAdsSpend')}
                </TableCell>
              )}
              {channel !== 'twitter' && channel !== 'instagram' && (
                <TableCell style={{ width: 50 }}>
                  {I18n.t('reporting.views')}
                </TableCell>
              )}
              {channel !== 'instagram' && (
                <TableCell style={{ width: 50 }}>
                  {channel === 'email'
                    ? I18n.t('reporting.bounces')
                    : I18n.t('reporting.actions')}
                </TableCell>
              )}
              {channel !== 'instagram' && (
                <TableCell style={{ width: 50 }}>
                  {I18n.t('reporting.clicks')}
                </TableCell>
              )}
              {channel !== 'email' && <TableCell style={{ width: 80 }} />}
              {channel === 'instagram' && (
                <>
                  <TableCell style={{ width: 50 }}>
                    {I18n.t('reporting.impressions')}
                  </TableCell>
                  <TableCell style={{ width: 50 }}>
                    {I18n.t('reporting.engagements')}
                  </TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <OrganicCampaignDetailsListItems
              campaign={campaign}
              channel={channel}
              stats={stats}
            />
            <TableRow>
              {channel === 'facebook' && (
                <TableCell className={classes.bottomCell} />
              )}
              <TableCell className={classes.bottomCell}>
                <Alert severity={'info'}>
                  {I18n.t('reporting.delayMessage')}
                </Alert>
              </TableCell>
              <TableCell className={classes.bottomCell} />
              <TableCell align="right" className={classes.bottomCell}>
                {channel === 'facebook' && (
                  <Typography variant="button">
                    <strong>Facebook {I18n.t('reporting.totals')}</strong>
                  </Typography>
                )}
              </TableCell>
              <TableCell align="center" className={classes.bottomCell}>
                {channel === 'facebook' ? (
                  <div>
                    {formatWithCents.format(
                      calculateLocalAdsSpend({ ads: campaign.localAds }) / 100,
                    )}
                  </div>
                ) : (
                  <Typography variant="button">
                    <strong>
                      {channel} {I18n.t('reporting.totals')}
                    </strong>
                  </Typography>
                )}
              </TableCell>
              {channel !== 'twitter' && (
                <TableCell align="center" className={classes.bottomCell}>
                  <Typography variant="button">
                    <strong>
                      {I18n.l(
                        'number',
                        channelTotals({ channel, stats, type: 'views' }),
                      )}
                    </strong>
                  </Typography>
                </TableCell>
              )}
              <TableCell align="center" className={classes.bottomCell}>
                <Typography variant="button">
                  <strong>
                    {I18n.l(
                      'number',
                      channel === 'email'
                        ? emailTotals({ type: 'bounced', stats })
                        : channelTotals({
                            channel,
                            stats,
                            type: 'actions',
                          }),
                    )}
                  </strong>
                </Typography>
              </TableCell>
              {channel !== 'instagram' && (
                <TableCell align="center" className={classes.bottomCell}>
                  <Typography variant="button">
                    <strong>
                      {I18n.l(
                        'number',
                        channelTotals({ channel, stats, type: 'clicks' }),
                      )}
                    </strong>
                  </Typography>
                </TableCell>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default OrganicCampaignDetailsList
